import { LOCAL_STORAGE } from 'app/commons/constants'
import { ICON_DELIVEREE_GREEN, ICON_TRANSPORTIFY_GREEN } from 'app/commons/constants/image.const'
import { modalCreateActions } from 'app/store/modal/modalSlice'
import { getAndCheckTokenCaptCha } from 'app/utils/authentication'
import { Formik } from 'formik'
import i18n from 'i18next'
import * as Yup from 'yup'

import React, { Component } from 'react'
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import ButtonSocial from 'app/components/Common/ButtonSocial'

import { MODAL_TYPES } from '../../commons/constants/modal.const'
import * as authActions from '../../store/auth/authAction'
import './style.scss'

const INIT_VALUES = { email: '', password: '' }

const SignupSchema = Yup.object().shape({
  email: Yup.string().required(i18n.t('common.login.thisFieldIsRequited')),
  password: Yup.string().required(i18n.t('common.login.thisFieldIsRequited')),
})

class Login extends Component {
  btnLogin

  constructor(props) {
    super(props)
    this.state = {
      showPassword: false,
    }
  }

  componentDidMount() {
    if (this.btnLogin) {
      this.btnLogin.focus()
    }
  }

  onClickSignUp() {
    const { openModal } = this.props
    openModal({ typeModal: MODAL_TYPES.SIGNUP })
  }

  handleSubmit = async (values) => {
    values.email = values.email.trim().toLowerCase()
    const { postSignIn, closeModal, handleGetAuth, googleReCaptchaProps, enableCaptchaVerification } = this.props
    const { email: login, password } = values
    const countryCode = localStorage.getItem(LOCAL_STORAGE.DEFAULT_COUNTRY)

    let xRecaptchaToken
    if (enableCaptchaVerification) {
      const executeRecaptcha = googleReCaptchaProps?.executeRecaptcha
      xRecaptchaToken = await getAndCheckTokenCaptCha(executeRecaptcha, 'login')
    }

    postSignIn({
      info: { login, password, country_code: countryCode },
      xRecaptchaToken,
      cb: (dataLogin) => {
        const { openModal } = this.props
        const accountId = dataLogin.currentCompanyId || dataLogin.id
        handleGetAuth({ accountId })
        if (dataLogin.must_update_password) {
          openModal({
            typeModal: MODAL_TYPES.RESET_PASSWORD,
            modalProps: { action: 4, prePassword: password },
          })
        } else {
          closeModal()
        }
      },
    })
  }

  render() {
    const { showPassword } = this.state
    const { t, openModal, closeModal } = this.props
    const countryCode = localStorage.getItem(LOCAL_STORAGE.DEFAULT_COUNTRY)

    const LOGO_ICON = countryCode === 'ph' ? ICON_TRANSPORTIFY_GREEN : ICON_DELIVEREE_GREEN
    return (
      <div className="popup-auth">
        <div className="auth-body login">
          <div className="auth-close">
            <i onClick={() => closeModal()} className="material-icons" role="presentation">
              close
            </i>
          </div>
          <div className="auth-logo">
            <img src={LOGO_ICON} alt="deliveree" />
          </div>
          <Formik initialValues={INIT_VALUES} validationSchema={SignupSchema} onSubmit={this.handleSubmit}>
            {(props) => {
              const { email, password } = props.errors
              const { handleSubmit } = props
              return (
                <form className="Form-Container" onSubmit={handleSubmit}>
                  {/* Email Input */}
                  <div className={`mb10 mx-auto ${!!email && props.touched.email && 'error'}`}>
                    <label htmlFor="email">{t('common.login.emailOrPhone')}</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control login-input"
                        id="email"
                        name="email"
                        value={props.values.email}
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                      />
                    </div>
                    {!!email && props.touched.email && <div className="error__message">{t(email)}</div>}
                  </div>

                  <div className={`mb20 mx-auto ${!!password && props.touched.password && 'error'}`}>
                    <label htmlFor="password" className="title-password">
                      <div>{t('common.login.password')}</div>
                      <div
                        onClick={() =>
                          openModal({
                            typeModal: MODAL_TYPES.RESET_PASSWORD,
                            modalProps: { action: 1 },
                          })
                        }
                      >
                        {t('common.login.forgot')}
                      </div>
                    </label>
                    <div className="input-group">
                      <input
                        type={`${showPassword ? 'input' : 'password'}`}
                        className="form-control login-password--input no-border-right"
                        id="password"
                        name="password"
                        onChange={props.handleChange}
                        value={props.values.password}
                        onBlur={props.handleBlur}
                      />
                      <div className={`input-group-text`}>
                        <i
                          onClick={() => {
                            this.setState({
                              showPassword: !showPassword,
                            })
                          }}
                          className={`material-icons cursor-pointer Icon xb ${showPassword ? 'green' : 'gray'}`}
                          role="presentation"
                        >
                          visibility
                        </i>
                      </div>
                    </div>
                    {!!password && props.touched.password && <div className="error__message">{t(password)}</div>}
                  </div>

                  <button
                    ref={(login) => {
                      this.btnLogin = login
                    }}
                    type="submit"
                    className="Button green w-100 h36 btn-login"
                  >
                    {t('common.login.logIn')}
                  </button>
                </form>
              )
            }}
          </Formik>
          <button className="Button transparent w-100 h36 mt10 mb20" onClick={() => this.onClickSignUp()}>
            {t('common.login.createAnAccount')}
          </button>
          <div className="Box-Content-Social-Line">
            <h5>{t('common.login.orLoginWith')}</h5>
            <div className="line"></div>
          </div>
          <ButtonSocial />
        </div>
      </div>
    )
  }
}

const mapState = (state) => ({
  loginState: state.auth.login,
  enableCaptchaVerification: state.configuration?.data?.enable_captcha_verification,
})

const actions = {
  ...authActions,
  ...modalCreateActions,
}

export default connect(mapState, actions)(withTranslation()(withRouter(withGoogleReCaptcha(Login))))
